<template>
    <VAppLayout>
        <VContainer>
            <CartTabText v-if="false" />

            <CartTab v-else
                     :orderId="orderId"
                     @show-regulamin="showRegulamin" />

        </VContainer>
        <vue-bottom-sheet ref="regulaminBottomSheet"
                          max-height="90%"
                          height="90%"
                          v-if="showSmRegulamin">
            <div class="pa-10"
                 style="white-space: pre-line;"
                 v-html="sm_terms">
            </div>
        </vue-bottom-sheet>
    </VAppLayout>
</template>

<script>

import VAppLayout from "@/layouts/VAppLayout.vue";
import VContainer from "@/components/ui/VContainer.vue";
import loader from "@/plugins/loader.plugin";
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import CartTab from "./components/CartTab.vue";
import CartTabText from "./components/CartTabText.vue";

export default {
    name: "Cart",
    props: ['orderId'],
    components: {
        VContainer,
        VAppLayout,
        VueBottomSheet,
        CartTab,
        CartTabText,
    },
    data() {
        return {
            loading: false,
            sm_terms: this.$store.getters['getCompanyData'].locale.sm_terms,
            sm_show_terms: this.$store.getters['getCompanyData'].locale.sm_show_terms,
        };
    },
    mounted() {
    },
    computed: {
        showSmRegulamin() {
            return (this.sm_show_terms && this.sm_terms && this.sm_terms.length > 0);
        },
        isWMM() {
            return this.$store.getters['getIsModeWMM'];
        }
    },
    methods: {
        showRegulamin() {
            this.$refs.regulaminBottomSheet.open();
        },
        showLoader() {
            this.loading = true;
            loader.show();
        },
        hideLoader() {
            this.loading = false;
            loader.hide();
        },

    }
};
</script>

<style lang="scss" scoped>
@import "src/scss/assets/variables";

ul,
li {
    margin: 0;
    padding: 0;
    list-style: none;
}

h6 {
    margin: 0;
    padding: 0;

    font: {
        size: 16px;
        weight: 700;
    }

    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
}

.cart {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 22px;
    height: 100%;
}

.cart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    &-content {
        position: relative;

        margin: 12px 0;

        &>h3 {
            font-size: 24px;
            font-weight: 700;
            margin: 20px 0;
            padding: 0;
        }

        &>span {
            position: absolute;
            bottom: 0;

            font: {
                size: 14px;
                weight: 500;
            }

            color: #929292;

            &:is(.hidden) {
                visibility: hidden;
            }
        }
    }

    &-logo {
        width: 66px;
        height: 66px;
        overflow: hidden;
        flex-shrink: 0;

        &>img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
}


.cart_plug {
    //padding: 22px 14px;
    //background-color: #F5F5F5;
    //border: 2px solid #E6E6E6;
    //border-radius: 20px;
    //display: flex;
    //justify-content: center;
    //align-items: center;
    //min-height: 150px;
    text-align: center;
    height: 100%;
    padding-top: 25%;

    .empty-cart-title {
        padding: 10% 0 5% 0;
        font-size: 1.5rem;
        color: black;
    }

    .empty-cart-message {
        //color: black;
    }
}

.cart_list.multiple-orders {
    display: flex;
    flex-direction: column;
    border: 2px solid rgba(230, 230, 230, 1);
    padding: 12px;
    gap: 12px;
    border-radius: 20px;
    box-shadow: 0 4px 30px 0 #0000001A;
    background-color: rgba(245, 245, 245, 1);

    &>ul {
        display: flex;
        flex-direction: column;
        gap: 30px;

        li {
            width: 100%;

            &>span {
                display: block;
                text-align: center;

                font: {
                    weight: 700;
                    size: 16px;
                }

                ;
                color: $color_black;
            }

            &>ul {
                display: flex;
                flex-direction: column;
                gap: 10px;
                padding: 12px;
                background-color: white;
                border-radius: 12px;

                li {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    p {
                        color: #000000;
                        font-size: 14px;
                        font-weight: 500;
                        margin: 0;

                        small {
                            color: #7019FD;
                            font-size: 14px;
                            font-weight: 500;
                        }

                    }

                    em {
                        color: $color_black;

                        font: {
                            size: 14px;
                            style: normal;
                            weight: 700;
                        }
                    }
                }
            }
        }
    }

    .cart_list-total {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid #E6E6E6;
        padding-top: 22px;
        color: $color_black;

        a.btn {
            height: 42px;
            width: 100%;
            font-size: 14px;
            border-radius: 10px;
        }

        span {
            font: {
                weight: 700;
                size: 16px;
            }
        }
    }

    &.multiple-orders {
        .cart_list-total {
            padding-top: 10px;
            border-top: none;

            div {
                width: 100%;
            }
        }
    }

    &.single-order {
        box-shadow: none;
        border: none;
        padding: 0;
    }
}

.cart_options {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-top: auto;
    padding-bottom: 24px;


    &.default_button {
        color: #6466f1;
        text-decoration: underline;
        font-size: 1.2em;
        text-align: center;
        padding-bottom: 15px;
    }

    &.regulamin_text {
        text-decoration: unset;
        display: block;

        a {
            color: #6466f1;
            text-decoration: underline;
        }
    }
}

.cart-delivery-wrap {
    margin-top: 22px;

    .cart-delivery-method {
        display: grid;
        gap: 14px;
    }

    .cart-delivery-fee {
        display: flex;
        justify-content: space-between;

        margin-top: 22px;

        font-weight: 510;
        font-size: 14px;
        letter-spacing: 0px;

        color: black;

        .price {
            font-weight: 700;

            margin-right: 12px;
        }
    }
}



.history-and-terms {
    //display: flex;
    width: 100%;
    justify-content: space-between;
}

.vat-rules-block {
    label {
        font-size: 14px;
        padding-left: 10px;
    }

    input[type="checkbox"] {
        width: 16px;
        height: 16px;
    }

    #phone-input {
        width: 100%;
        font-size: 16px;
        display: flex;
        flex-direction: column;
        border: 2px solid #E6E6E6;
        padding: 12px 20px;
        border-radius: 12px;
        box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.1019607843);
        margin-top: 15px;
        color: black;
        height: 50px;
    }

    p {
        padding: 10px;
        color: red;
        border: 1px solid #FF3737;
        background: #FFDBDB36;
        border-radius: 13px;
        margin: 5px 0px 0px;
    }

    .phone_info {
        display: flex;
        margin-top: 10px;
        padding-left: 3px;
        margin-bottom: 25px;

        img {
            height: 16px;
            width: 16px;
            margin-right: 7px;
        }

        svg {
            margin-right: 7px;

        }
    }
}

.adult-agreement {
    label {
        padding-left: 0;
    }
}

.catalog_list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}


.v-counter {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    &__value {
        min-width: 22px;
        display: flex;
        align-items: center;
        justify-content: center;

        &>span {
            font: {
                weight: 700;
                size: 16px;
            }

            letter-spacing: -1px;
            color: $color_black;
        }
    }
}

.hidden {
    display: none !important;
}

#regulamin-link {
    text-decoration: underline;
}
</style>

<style>
.bottom-sheet__content {
    touch-action: unset !important;
    -webkit-user-select: unset !important;
    -webkit-touch-callout: unset !important;
    -webkit-user-drag: unset !important;
}
</style>
